import { enum_ } from 'valibot'

export type HasEntityTypeId = {
  /**
   * EntityTypeId
   */
  etype_id: EntityTypeId
}



export enum EntityTypeId {
  // Void = 0

  // L1

  Sea = 2,
  River = 5,
  Lake = 6,  // non-moving river
  Marsh = 7, // grass wetland
  Swamp = 8, // trees wetland
  Shoal = 10, // a beach

  Plain = 11,
  Snow = 12,
  Desert = 13,
  Mountain = 14,

  Forest = 15,
  Jungle = 16,
  Deadwood = 17, // Twisted dead trees, cracked soil, faded color palette

  // L2
  Road = 22,
  // RoughSea = 32,
  // Reef = 33,

  // L3
  Building = 40,
  HQ = 41,
  Factory = 42,
  // Airport,
  // Harbor,
  // ResearchLab,
  // ComsTower,
  // MissleSilo,
  // Radar,
  // Ruins,

  // L4
  // Fog = 60
  // Wind,

  // L5
  // Submarine = 80,

  // L6
  Infantry = 100,

  // L7
  LightRecon = 120, // humvees
  // MediumRecon = 121,
  // HeavyRecon = 122,
  // IFV, // IDK, sounds like armored LightRecon or APC with gun holes
  APC = 123, // M113

  // Booker 105mm cannon
  LightTank = 124, // M2 Bradley IFV // 25mm autocannon
  MediumTank = 125, // M1 Abrams 120mm cannon
  HeavyTank = 126, // DNE

  LightArtillary = 127, // DNE
  MediumArtillary = 128, // Type 99 155 mm self-propelled howitzer
  HeavyArtillary = 129, // DNE

  LightRockets = 130, // DNE
  MediumRockets = 131, // M142 HIMARS
  HeavyRockets = 132, // M270 MLRS

  LightGunAntiAir = 133, // DNE
  MediumGunAntiAir = 134, // M247 Sergeant York
  HeavyGunAntiAir = 135, // DNE

  LightMissileAntiAir = 137, // DNE
  MediumMissileAntiAir = 138, // P4R Crotale
  HeavyMissileAntiAir = 139, // DNE

  // L7
  TransportCopter = 140, // CH47 Chinook
  LightCopter = 141, // DNE
  MediumCopter = 142, // AH64 Apache // 30mm M230 chain gun // Hydra 70 AirToGround rockets // AGM-114 Hellfire Anti-Armor missile
  HeavyCopter = 143, // DNE

  // Rocket = unguided, Missile = guided

  // L8
  // FighterPlane = 160,
  // BomberPlane,

  // L9
  // Satellite = 180,
}

export const EntityTypeIdSchema = enum_(EntityTypeId, 'Invalid Entity Type ID')
